import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { setSideMenuOpen } from 'actions/app_action';
import { useUnsavedChangesModal } from 'hooks/modals/unsaved-changes.modal/unsaved-changes.modal';

import { useMenuItems } from '../hooks/use-menu-items';
import MenuItem from '../menu-item';
import { useExpandedMenuState } from '../hooks/use-expanded-menu-state';
import type { MainMenuItem } from '../side-menu-interfaces';

type MenuProps = {
  isMinimized: boolean;
};

const Menu = ({ isMinimized }: MenuProps) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { openUnsavedChangesModal } = useUnsavedChangesModal();
  const { menuItems } = useMenuItems();

  const { expandedMenuState, toggleMenuItem, syncExpandedStateWithLocation } = useExpandedMenuState(
    location,
    menuItems
  );

  const handleMenuItemToggle = useCallback(
    (menuItem: MainMenuItem) => {
      const hasSubMenu = menuItem.subMenuItems.length > 0;

      if (!hasSubMenu && menuItem.links) {
        const link = menuItem.links[0];
        openUnsavedChangesModal(() => {
          history.push(link);
          dispatch(setSideMenuOpen(false));
        });
        return;
      }

      toggleMenuItem(menuItem);
    },
    [toggleMenuItem]
  );

  useEffect(() => {
    syncExpandedStateWithLocation();
  }, [location, menuItems, syncExpandedStateWithLocation]);

  return (
    <>
      {menuItems.map(menuItem => (
        <MenuItem
          key={menuItem.menuTitle}
          expanded={expandedMenuState[menuItem.menuTitle] ?? false}
          item={menuItem}
          isMinimized={isMinimized}
          toggleExpandItem={handleMenuItemToggle}
        />
      ))}
    </>
  );
};

export default Menu;
